import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/input/Button';
import { useRouter } from 'found';
import {
  RadioList,
  SelectOption,
  SelectTitle,
  SelectDescription,
} from '../../components/RadioList';
import Spacer from '../../components/Spacer';
import { Heading } from '../../components/typography/Typography';
import { routes } from '../../routes';
import { HelpText } from '../../components/HelpText';

const Container = styled.div`
  width: 90vw;
  @media (min-width: 1200px) {
    width: 341px;
  }
`;

function AccountSelect() {
  const [selected, setSelected] = useState<number | undefined>();
  const { router } = useRouter();

  const onCreateAccount = () => {
    switch (selected) {
      case 0:
        router.push(routes.customerSignup);
        break;
      case 1:
        router.push(routes.merchantSignup);
        break;
      default:
        break;
    }
  };
  return (
    <Container>
      <Heading>Create an account</Heading>
      <RadioList>
        <SelectOption onClick={() => setSelected(0)} selected={selected === 0}>
          <SelectTitle>Customer</SelectTitle>
          <Spacer vertical spacing={1} />
          <SelectDescription>
            Use and pay for APIs, manage your usage and subscriptions
          </SelectDescription>
        </SelectOption>
        <Spacer vertical spacing={4} />
        <SelectOption onClick={() => setSelected(1)} selected={selected === 1}>
          <SelectTitle>Merchant</SelectTitle>
          <Spacer vertical spacing={1} />
          <SelectDescription>
            Charge for your APIs and get detailed stats on usage.
          </SelectDescription>
        </SelectOption>
      </RadioList>
      <Spacer vertical spacing={4} />
      <Button
        color='white'
        disabled={selected === undefined}
        onClick={onCreateAccount}
      >
        Create Account
      </Button>
      <Spacer vertical spacing={4} />
      <HelpText>
        You can choose to become a merchant, or a customer later if you would
        like to be both.
      </HelpText>
    </Container>
  );
}

export default AccountSelect;
